// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--f5a37";
export var square = "Checkbox-module--square--61798";
export var input = "Checkbox-module--input--ac454";